import { Fab, Grid, Paper, Tab, Tabs, Theme, Tooltip, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import merge from 'deepmerge';
import { isBrowser } from 'react-device-detect';
import React, { useGlobal } from 'reactn';
import IForfettariAppBar from '../../appBar/IForfettariAppBar';
import ProgressBar from '../../progress/ProgressBar';
import TabPanel from '../../components/TabPanel';
import '../../css/media-query-styles.css';
import { IGlobalState,  initialState, initialStateSimulazioniSrl } from '../../states/GlobalState';
import { loggaAccesso } from '../../services/common';
import { SimulazioniSrlDataClass } from '../../states/SimulazioneSrlState';
import Auth from '../../types/auth';
import { Applicazioni, TabIForfettari, LoadTelematico } from '../../types/types';
import { tabsSimulazioniSrl } from '../../types/constants';
import CompDivSimulazioniSrl from './CompDivSimulazioniSrl';
import DatiSimulazioniSrl, { SimulazioniSrlInputProps } from './DatiSimulazioniSrl';
import NormaleSimulazioniSrl from './NormaleSimulazioniSrl';
import RiepilogoSimulazioniSrl from './RiepilogoSimulazioniSrl';
import SoloCompSimulazioniSrl from './SoloCompSimulazioniSrl';
import SoloDivSimulazioniSrl from './SoloDivSimulazioniSrl';
import TraspCompSimulazioniSrl from './TraspCompSimulazioniSrl';
import TraspSimulazioniSrl from './TraspSimulazioniSrl';
import ComputerIcon from '@material-ui/icons/Computer';
import { API_elaboraConvSrlGlobal } from '../../utils/functions';
import { useLogger } from '../../logger';
import Main from '../../components/main';
import {useHistory } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fabVariants } from '../../animation/variants';
import DialogTelematico from '../../telematico/dialogTelematico';
import { loadDatiFromTelematicos } from '../../services/telematicoService';
import { fillDataPFTelematicoToConvenienza, fillDataSocioTelematicoToConvenienza } from '../../telematico/convenienzaFunctions';

function reducerSimulazioniSrl(state: SimulazioniSrlDataClass, action: any = undefined) {
  console.log('Reducer simulazioni: ' + action.type);
  console.log(action);
  let s: SimulazioniSrlDataClass;
  switch (action.type) {
    case 'setLoading':
      s = {
        ...state,
        loading: action.value
      };
      return s;
    case 'reset':
      return initialStateSimulazioniSrl;
    case 'set':
      s = { ...action.value };
      let newState = merge(initialState, s);
      return newState;
    case 'count':
      s = { ...action.value };
      let countState = merge(state, s);
      return countState;
    case "changeDatiSimulazioniSrl":
      s = {
        ...state,
        datiSimulazioniSrl: {
          ...state.datiSimulazioniSrl,
          [action.name]: action.value
        }
      };
      return s;
    // return calcolaSimulazioniSrl(s, action);
    default:
      throw new Error();
  }
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      // width: `calc(100% - ${drawerWidth}px)`,
      // marginLeft: drawerWidth,
      // transition: theme.transitions.create(['margin', 'width'], {
      //   easing: theme.transitions.easing.easeOut,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),
    },
    tabsBar: {
      boxShadow: "0px 4px 7px 3px #ccc",
      position: "fixed",
      zIndex: 1000,
    },
    tabsBarShift: {
      boxShadow: "0px 4px 7px 3px #ccc",
      position: "fixed",
      zIndex: 1000,
    },
    tabColorati: {
      transitionTimingFunction: 'ease-in',
      transition: 'background 0.5s',
      '&:hover': {
        background: theme.palette.secondary.main,
      },
      flex: '0 1 auto',
      // width: ''
    },
    testoColorato: {
      '&:hover': {
        color: '#fff'
      }
    },
    button: {
      backgroundColor: 'rgba(0, 161, 216, 0.8)', // blue[100],
      color: '#fff',
      '&:hover': {
          backgroundColor: 'rgba(0, 161, 216, 1.0)'
      },
      '&:pressed': {
          backgroundColor: 'rgba(0, 161, 216, 1.0)'
      }
    },
    // Media query for the tabs menu, sotto i 400px siamo in flex start
    justifyTabs: {
      paddingTop: '20px',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-start',        
      },
      [theme.breakpoints.up('md')]: {
        justifyContent: 'center',
      },
      [theme.breakpoints.up('lg')]: {
        justifyContent: 'center',
      },
    },
  }),
);

export default function IConvSrlHome() {
  const [stateSimSrl, dispatchSimSrl] = React.useReducer(reducerSimulazioniSrl, initialStateSimulazioniSrl);
  // eslint-disable-next-line
  const [identity] = useGlobal<IGlobalState, 'identity'>('identity');
  const [global] = useGlobal<IGlobalState>();
  const [userLogged,setUserLogged] = useGlobal<IGlobalState, 'userLogged'>('userLogged');
  const [tab, setTab] = React.useState(TabIForfettari.Dati as number);
  const [open,] = React.useState(false);
  const [,setApplication] = useGlobal<IGlobalState, 'application'>('application');
  const logger = useLogger({key: 'identity'});
  const history = useHistory();
  const [title, ] = useGlobal<IGlobalState, 'title'>('title');
  const [caricaDatiTelematicoOpen, setCaricaDatiTelematicoOpen] = React.useState<boolean>(false);
  const [, setGlobalWait] = useGlobal<IGlobalState, 'globalWait'>('globalWait');
  const [auth,] = useGlobal<IGlobalState, 'auth'>('auth');
  const [ip,] = useGlobal<IGlobalState, 'ip'>('ip');

  let apptabs = tabsSimulazioniSrl;

  // const username = Auth.getUsername(global);
  const username = identity?.Username!;
  // console.log('Sono in HOME Convenienza CON USERNAME: ' + username);

  const handleChangeSimSrl = (type: string, name: string, value: any) => {
    console.time('dipatch convenienza ' + type + ' name: ' + name);
    dispatchSimSrl({ type, name, value });
    // console.timeEnd('dipatch convenienza ' + type);
  }

  function handleTabChange(event: React.ChangeEvent<{}>, newValue: TabIForfettari) {
    setTab(newValue);
  }

  function verifyApplicationPrincipal() {
    if (!identity || identity.ApplicationConvenienza !== true) {
      logger.error('Diritto mancante sulla applicazione Convenienza');
      history.push('/home');
    }
  }
  
  function a11yProps(index: any) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  //HACK vmorell 20210303
  // Function to calculate forfetari   
  function handleClickConvSrl(stateConv: SimulazioniSrlDataClass) {
    console.log('ho lanciato il calcolo conv Srl con lo stato: ' + JSON.stringify(stateConv))
    let props: SimulazioniSrlInputProps = {state: stateConv, handleChange: handleChangeSimSrl, username: username};

    API_elaboraConvSrlGlobal(props, global);
  }

  //END HACK vmorell

  function handleResetState() {
    dispatchSimSrl({ type: 'reset' });
  }

  function handleLoadState(newState: SimulazioniSrlDataClass, applicazione: number) {
    console.time('loadState');
    if (applicazione === Applicazioni.ConvSrl) {
      dispatchSimSrl({ type: 'set', value: newState });
    }
    console.timeEnd('loadState');
  }
    
  const handleOpenLoadData = () => {
    setCaricaDatiTelematicoOpen(true);
  }
  
  const handleClose = (e: any) => {
    setCaricaDatiTelematicoOpen(false);
  }
  
  const handleSubmitLoadTelematico = (values: LoadTelematico) => {    
    setGlobalWait(true);
    loadDatiFromTelematicos(ip, auth.authData!, auth.user!, values).then(res => {
      console.log('Chiamo la fill convenienza per impresa');
      console.log('Res FROM convenienza per is: ' + JSON.stringify(res));
      
      if (res.primoCF === null && res.collab1CF === null && res.collab2CF === null && res.socio3CF === null) {
        logger.error("Nessun dato recuperato", "Carica telematico");        
      } else {
        fillDataPFTelematicoToConvenienza(res.primoCF, stateSimSrl);
        // Fill data for the Soci
        fillDataSocioTelematicoToConvenienza(res.collab1CF, stateSimSrl, 1);
        fillDataSocioTelematicoToConvenienza(res.collab2CF, stateSimSrl, 2);
        fillDataSocioTelematicoToConvenienza(res.socio3CF, stateSimSrl, 3);
        logger.info("Caricamento avvenuto con successo", "Carica telematico");
      }
      setCaricaDatiTelematicoOpen(false);
    })
    .catch(error => {
      logger.error('Errore ' + error.statusText);
    })
    .finally(() => setGlobalWait(false))    
  }
  
  React.useEffect(() => {
    // check the boundaryError
    setApplication(Applicazioni.ConvSrl);

    if (identity) {
      console.log('Identity HOME is set ');
      verifyApplicationPrincipal();    
    } else {
      console.log('Identity HOME is null');
    }          

    if (username && username !== '' && (!userLogged || userLogged !== username)) {
      console.log('Loggo in Tabella login e verifico utente');
      setUserLogged(identity?.Username!);
      loggaAccesso(Auth.getProvincia(global)!, identity?.Username!, Applicazioni.ConvSrl, global).then(res => {
        console.log('Loggo ritorna: ' + res);
        if (res === false) {
          global.auth.userManager.signoutRedirect();        
        }
      })
      // verifyUser(global.ip, global.auth, global.auth.user!, username);
    } else {
      console.log('Loggo non eseguito');
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [username]);
  
  const classes = useStyles();
  let isloading = stateSimSrl.loading;
  
  return (
    <div style={{ backgroundColor: "#e3e3e3", minHeight: "100vh"}}>
      <IForfettariAppBar title={title} handleLoad={handleChangeSimSrl} stateSimSrl={stateSimSrl} handleChange={handleTabChange} loadState={handleLoadState} resetState={handleResetState} apptabs={apptabs}></IForfettariAppBar>
      <ProgressBar isOpen={isloading}></ProgressBar>
      <Main>
        <Grid
            className={classes.justifyTabs}
            container
            direction="row"
            alignItems="center"        
        >
            <Paper className={clsx(classes.tabsBar, {
            [classes.tabsBarShift]: open && isBrowser,
            })}>
            <Tabs value={tab} onChange={handleTabChange} textColor="secondary" scrollButtons='on'>
                {
                apptabs.map((text, index) => (
                    <Tab className={classes.tabColorati} key={index} label={<Typography className={classes.testoColorato} variant="button" color={index === 0 ? "primary" : "secondary"}>{text}</Typography>}{...a11yProps(index)}></Tab>
                ))
                }
            </Tabs>
            </Paper>
        </Grid>
        <Grid
            id="print"
            container
            direction="column"
            justify="flex-start"
            alignItems="center"
        >
            <React.Fragment>
              <TabPanel show={tab === 0} index={0}>
                <Grid
                  className={clsx(classes.appBar, {
                    [classes.appBarShift]: open && isBrowser,
                  })}
                  container
                  direction="column"
                  justify="flex-start"
                  alignItems="center"
                >
                  <DialogTelematico state={stateSimSrl} caricaDatiTelematicoOpen={caricaDatiTelematicoOpen} handleClose={handleClose} handleSubmitLoadTelematico={handleSubmitLoadTelematico} isConvenienza={true}></DialogTelematico>
                  <DatiSimulazioniSrl state={stateSimSrl} handleChange={handleChangeSimSrl} global={global} handleOpenLoadData={handleOpenLoadData}></DatiSimulazioniSrl>
                </Grid>
              </TabPanel>
              <TabPanel show={tab === 1} index={1}>
                <Grid
                  className={clsx(classes.appBar, {
                    [classes.appBarShift]: open && isBrowser,
                  })}
                  container
                  direction="column"
                  justify="flex-start"
                  alignItems="center"
                >
                  <NormaleSimulazioniSrl state={stateSimSrl} handleChange={handleChangeSimSrl}></NormaleSimulazioniSrl>
                </Grid>
              </TabPanel>
              <TabPanel show={tab === 2} index={2}>
                <Grid
                  className={clsx(classes.appBar, {
                    [classes.appBarShift]: open && isBrowser,
                  })}
                  container
                  direction="column"
                  justify="flex-start"
                  alignItems="center"
                >
                  <SoloCompSimulazioniSrl state={stateSimSrl} handleChange={handleChangeSimSrl} username={username}></SoloCompSimulazioniSrl>
                </Grid>
              </TabPanel>
              <TabPanel show={tab === 3} index={3}>
                <Grid
                  className={clsx(classes.appBar, {
                    [classes.appBarShift]: open && isBrowser,
                  })}
                  container
                  direction="column"
                  justify="flex-start"
                  alignItems="center"
                >
                  <SoloDivSimulazioniSrl state={stateSimSrl} handleChange={handleChangeSimSrl} username={username}></SoloDivSimulazioniSrl>
                </Grid>
              </TabPanel>
              <TabPanel show={tab === 4} index={4}>
                <Grid
                  className={clsx(classes.appBar, {
                    [classes.appBarShift]: open && isBrowser,
                  })}
                  container
                  direction="column"
                  justify="flex-start"
                  alignItems="center"
                >
                  <CompDivSimulazioniSrl state={stateSimSrl} handleChange={handleChangeSimSrl} username={username}></CompDivSimulazioniSrl>
                </Grid>
              </TabPanel>
              <TabPanel show={tab === 5} index={5}>
                <Grid
                  className={clsx(classes.appBar, {
                    [classes.appBarShift]: open && isBrowser,
                  })}
                  container
                  direction="column"
                  justify="flex-start"
                  alignItems="center"
                >
                  <TraspSimulazioniSrl state={stateSimSrl} handleChange={handleChangeSimSrl} username={username}></TraspSimulazioniSrl>
                </Grid>
              </TabPanel>
              <TabPanel show={tab === 6} index={6}>
                <Grid
                  className={clsx(classes.appBar, {
                    [classes.appBarShift]: open && isBrowser,
                  })}
                  container
                  direction="column"
                  justify="flex-start"
                  alignItems="center"
                >
                  <TraspCompSimulazioniSrl state={stateSimSrl} handleChange={handleChangeSimSrl} username={username}></TraspCompSimulazioniSrl>
                </Grid>
              </TabPanel>
              <TabPanel show={tab === 7} index={7}>
                <Grid
                  className={clsx(classes.appBar, {
                    [classes.appBarShift]: open && isBrowser,
                  })}
                  style={{ minHeight: "100vh" }}
                  container
                  direction="column"
                  justify="flex-start"
                  alignItems="center"
                >
                  <RiepilogoSimulazioniSrl state={stateSimSrl} handleChange={handleChangeSimSrl} username={username}></RiepilogoSimulazioniSrl>
                </Grid>
              </TabPanel>
              {tab !== 7 ? 
              (<Tooltip title="Calcola convenienza Srl">
                <Fab 
                    className={classes.button}
                    style={{position: 'fixed', bottom: 20, right: 20}}
                    color="inherit"
                    size="large"
                    onClick={(e: any) => handleClickConvSrl(stateSimSrl)}
                >
                    <motion.div
                      variants={fabVariants}
                      initial="hidden"
                      animate="visible"
                      style={{verticalAlign: 'middle'}}
                    >
                      <ComputerIcon />
                    </motion.div>
                </Fab>
              </Tooltip>
              ) 
              : 
              null }
            </React.Fragment>
        </Grid>
      </Main>    
    </div>
  );
}